/**
 * @file Layout header
 * @author zhangyou
 */
import React, { useRef } from 'react'
import styled from 'styled-components'
import Actions from '../HeaderActions'
import AppList from '../AppList'
import Logo from './Logo'

const Header = styled.div`
  position: sticky;
  top: 0;
  height: ${(props) => `${props.theme.headerHeight}px`};
  display: flex;
  color: #fff;
  background: #fff;
  z-index: 201;
  .isInIframe.noAppList &,
  .isEmptyLayout & {
    display: none;
  }
  .tnt-themeS1 & {
    background: #323b4a;
  }
  padding-right: 20px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    -webkit-box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  .paas-header-actions {
    li {
      .tnt-themeS1 & {
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }
`

const Content = styled.div`
  flex: 1;
  .isInIframe & {
    display: none;
  }
`

export default (props) => {
  const {
    logo,
    name,
    enName,
    language,
    selectedAppKey,
    appList,
    onLogoClick,
    onAppChange,
    extraActions,
  } = props
  const config = {
    application: true,
    ...props.config,
  }
  const headerRef = useRef()

  return (
    <Header ref={headerRef}>
      <Logo language={language} logo={logo} name={name} enName={enName} onClick={onLogoClick} />
      {appList && <AppList items={appList} selectedKey={selectedAppKey} onChange={onAppChange} />}
      <Content>{props.children}</Content>
      <Actions {...props} config={config} headerRef={headerRef} className="paas-header-actions">
        {extraActions}
      </Actions>
    </Header>
  )
}
